'use client';
import { useEffect, useMemo, useState } from 'react';

import { motion } from 'framer-motion';

import { useModal } from '@/components/modals/useModal';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MoveRight, PhoneCall } from 'lucide-react';
import Link from 'next/link';

export const Hero = () => {
  const { openModal } = useModal('login');
  const [titleNumber, setTitleNumber] = useState(0);

  const titles = useMemo(() => ['medical', 'healthcare', 'and more'], []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (titleNumber === titles.length - 1) {
        setTitleNumber(0);
      } else {
        setTitleNumber(titleNumber + 1);
      }
    }, 2000);
    return () => clearTimeout(timeoutId);
  }, [titleNumber, titles]);

  return (
    <div className='w-full'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center justify-center gap-8 py-20 lg:py-40'>
          <div>
            <Badge variant='outline'>We&apos;re live!</Badge>
          </div>
          <div className='flex flex-col gap-4'>
            <h1 className='font-regular max-w-2xl text-center text-5xl tracking-tighter md:text-7xl'>
              <span className='text-spektr-cyan-50'>Billing Services</span>
              <span className='relative flex w-full justify-center overflow-hidden text-center md:pb-4 md:pt-1'>
                &nbsp;
                {titles.map((title, index) => (
                  <motion.span
                    key={index}
                    className='absolute font-semibold'
                    initial={{ opacity: 0, y: '-100' }}
                    transition={{ type: 'spring', stiffness: 50 }}
                    animate={
                      titleNumber === index
                        ? {
                            y: 0,
                            opacity: 1,
                          }
                        : {
                            y: titleNumber > index ? -150 : 150,
                            opacity: 0,
                          }
                    }
                  >
                    {title}
                  </motion.span>
                ))}
              </span>
            </h1>

            <p className='max-w-2xl text-center text-lg leading-relaxed tracking-tight text-muted-foreground md:text-xl'>
              Streamline your practice with our End-to-End Medical Billing &
              Revenue Cycle Solutions. From patient registration to claims
              submission and payment posting, we provide comprehensive services
              that enhance efficiency, ensure compliance, and maximize revenue
              for healthcare providers.
            </p>
          </div>
          <div className='flex flex-row gap-3'>
            <Button size='lg' className='gap-4' variant='outline' asChild>
              <Link href='/#contact' className='flex items-center gap-4'>
                Jump on a call <PhoneCall className='h-4 w-4' />
              </Link>
            </Button>
            <Button
              size='lg'
              className='flex items-center gap-4'
              onClick={openModal}
            >
              Sign in here <MoveRight className='h-4 w-4' />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
